// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Delivery zones  (customer side)
// Loads the active delivery zones once (GET /public/zones). `loaded` is false until the answer arrives; if the request fails the customer site behaves as if nothing is enforced
// (the backend still refuses an out-of-zone order, so a failed read never lets one through — it only hides the early warning).
// Neighbours: utils/zones, pages/Checkout, components/delivery/AddressForm.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import { fetchPublicZones, type PublicZones } from "../utils/zones";

export interface ZonesState extends PublicZones { loaded: boolean }
const EMPTY: ZonesState = { enforced: false, zones: [], loaded: false };

export default function useZones(): ZonesState {
  const [state, setState] = useState<ZonesState>(EMPTY);
  useEffect(() => {
    let live = true;
    fetchPublicZones().then((z) => live && setState({ ...z, loaded: true }), () => live && setState({ ...EMPTY, loaded: true }));
    return () => { live = false; };
  }, []);
  return state;
}
